import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants/primitives';

export * from 'pages/cart/details/base.styled';

export const IconStyled = Icon.withConfig(props => ({
  size: 5,
  marginRight: '$1',
  color: props.disabled ? primitive.$blackOpacity50 : primitive.$black,
}));

export const WidgetBaseStyles = StyleSheet.create({
  container: {
    backgroundColor: primitive.$white,
    borderRadius: 10,
    padding: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
